import get from 'lodash/get';
import { hasRole } from '../utils/has-role';
import { APPLICATIONS } from '../app-config';
import { REDIRECT_STORAGE_KEY } from './';
import { oktaWidgetInstance } from '../components/OktaWidget/okta-widget-wrapper';
import { ROUTES } from '../navigation/router';
import envConfig from '../config/config';

export async function revokeTokenAndRedirect(redirectURL, hasFocus = false) {
  const accessToken = await oktaWidgetInstance.authClient.tokenManager.get('accessToken');
  if (accessToken) {
    await oktaWidgetInstance.authClient.token.revoke(accessToken);
  }
  await oktaWidgetInstance.authClient.tokenManager.clear();

  let url;
  try {
    // Try to create a URL object with the provided redirectURL
    url = new URL(redirectURL, window.location.origin);
  } catch (e) {
    // If it fails, log the error
    console.error('Invalid URL:', redirectURL);
    return;
  }

  url.searchParams.append('hasFocus', hasFocus);

  window.location = url.href;
}

export async function resetOkta() {
  await attemptCloseOktaSession();
  await oktaWidgetInstance.authClient.tokenManager.clear();
  localStorage.clear();
  sessionStorage.clear();
  await revokeTokenAndRedirect(ROUTES.ROOT);
}

async function attemptCloseOktaSession() {
  try {
    await oktaWidgetInstance.authClient.session.close();
  } catch (error) {}
}

export function getAppsFromAccessToken(accessToken) {
  const roles = get(accessToken, ['claims', 'sundial_roles'], get(accessToken, ['accessToken', 'sundial_roles'], []));

  return APPLICATIONS.filter((app) => roles.some((role) => hasRole(app.roles, role.split(':')[1])));
}

export function setOrRemoveRedirectUrl(redirect) {
  if (redirect) {
    const redirectUrl = new URL(redirect);
    // Only allow redirects to Tempus domains.
    if (
      envConfig.whitelistedRedirectDomain.some((suffix) => {
        return redirectUrl.hostname.endsWith(suffix);
      })
    ) {
      window.sessionStorage.setItem(REDIRECT_STORAGE_KEY, redirect);
    }
  } else {
    // Clear if no redirect
    window.sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
  }
}
